import styled from '@emotion/styled';
import { message } from 'antd';
import { useTranslate } from '@tolgee/react';
import ItemCard, { ItemCardData } from 'components/ItemCard';
import SellerCenter from 'components/SellerCenter';
import { goItemSellerCenter } from 'views/Conversation/Sider/ProductComponent';
import Icon from '@ant-design/icons';
import TextButton from 'components/TextButton';
import { ReactComponent as LinkSvg } from 'assets/icons/link.svg';
import CardMessage, { CardMessageProps } from './CardMessage';
import { useChatConversationContext } from 'views/Conversation/Chat/contexts/ChatConversationContext';
import { isSupportSellerCenterURL } from 'utils/sellerCenterURL';

export interface ItemCardMessageData extends ItemCardData {
  link: string;
}

export interface ItemCardMessageProps extends CardMessageProps {
  className?: string;
  dataSource: ItemCardMessageData;
  isUserEnter?: boolean;
}

const Footer = styled.div`
  margin-top: 8px;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 8px;
  border-top: 1px dashed var(--fett-border-default);
`;

const UserEnter = styled.div`
  margin-top: 8px;
  padding-top: 4px;
  border-top: 1px dashed var(--fett-border-default);
  text-align: left;
`;

const ItemCardMessage = (props: ItemCardMessageProps) => {
  const { t } = useTranslate();

  const { currentConversation: conversation } = useChatConversationContext();

  const { className, dataSource, isUserEnter = false, lazyScrollContainer, ...oProps } = props;
  const stockStatusLabelMap = {
    InStock: t('stock.exist'),
    PartialOutOfStock: t('outofstock_partial_sku_out'),
    OutOfStock: t('ViewDashboard.LAZADA.Out of stock'),
  };

  return (
    <CardMessage className={className} {...oProps}>
      <ItemCard
        dataSource={dataSource}
        platform={conversation?.channel}
        region={conversation?.region}
        lazyScrollContainer={lazyScrollContainer}
      />
      <Footer>
        <div
          style={{
            color: ['PartialOutOfStock', 'OutOfStock'].includes(dataSource?.spuStockStatus)
              ? 'var(--fett-surface-error-text)'
              : 'var(--fett-scenario-success-text)',
            fontSize: '12px',
          }}
        >
          {stockStatusLabelMap?.[dataSource?.spuStockStatus]}
        </div>
        {conversation && isSupportSellerCenterURL(conversation.channel) ? (
          <div>
            <SellerCenter platform={conversation.channel}>
              <TextButton
                onClick={() => {
                  goItemSellerCenter(
                    conversation.storeId,
                    `${dataSource.id}`,
                    conversation.channel,
                  ).catch(() => {
                    message.error(t('sider.打开卖家中心失败，请稍后再试'));
                  });
                }}
              >
                {t('sider.去卖家中心查看')}
                <Icon component={LinkSvg} style={{ marginLeft: 4 }} />
              </TextButton>
            </SellerCenter>
          </div>
        ) : null}
        {isUserEnter && <UserEnter>{t('messageType.SYS_USER_ENTER_FROM_ITEM')}</UserEnter>}
      </Footer>
    </CardMessage>
  );
};

export default ItemCardMessage;
